import { render, staticRenderFns } from "./MobileBottomAppBar.vue?vue&type=template&id=05f5ba67&"
import script from "./MobileBottomAppBar.vue?vue&type=script&lang=ts&"
export * from "./MobileBottomAppBar.vue?vue&type=script&lang=ts&"
import style0 from "./MobileBottomAppBar.vue?vue&type=style&index=0&id=05f5ba67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports